import { createAsyncThunk } from "@reduxjs/toolkit";
import { get } from "../../Services/ApiBase";
import { API_ENDPOINTS } from "../../Services/ApiEndPoints";
import { getApiErrorMessage } from "../../utils/apiErrorMessage";

const DASHBOARD_QUERY_KEYS = ["taskDateFrom", "taskDateTo", "bugDateFrom", "bugDateTo"];

function pickDashboardQuery(params) {
  const p = params && typeof params === "object" ? params : {};
  const query = {};
  for (const key of DASHBOARD_QUERY_KEYS) {
    const v = p[key];
    if (v != null && String(v).trim() !== "") query[key] = String(v).trim();
  }
  return query;
}

/**
 * GET /dashboard — optional query: taskDateFrom, taskDateTo, bugDateFrom, bugDateTo (YYYY-MM-DD).
 * Pass a flat object from `buildDashboardQueryParams` (see utils/dashboardQueryParams.js) or `{}` for defaults.
 */
export const fetchDashboardData = createAsyncThunk(
  "dashboard/fetchData",
  async (params = {}, { rejectWithValue }) => {
    try {
      const query = pickDashboardQuery(params);
      const response = await get(API_ENDPOINTS.DASHBOARD.GET, query);
      return response.data;
    } catch (error) {
      return rejectWithValue(getApiErrorMessage(error, "Failed to fetch dashboard data"));
    }
  }
);
